import { bindable, resolve } from 'aurelia';
import { IAuth } from '../services/auth';
import { ISound } from '../services/sound';
import { IFirebase } from '../services/firebase';

export class LoginPanel {
  @bindable close: () => void = () => {};
  auth = resolve(IAuth);
  sound = resolve(ISound);
  fb = resolve(IFirebase);
  username = '';
  error = '';
  input!: HTMLInputElement;

  bound(): void {
    this.username = this.auth.lastUsername;
  }

  attached(): void {
    void this.auth.detectKeychain();
    this.input?.focus();
  }

  async devSubmit(): Promise<void> {
    this.error = '';
    try {
      await this.auth.loginDev(this.username);
      this.sound.coin();
      this.close();
    } catch (e: any) {
      this.error = e?.message ?? String(e);
    }
  }

  async submit(): Promise<void> {
    this.error = '';
    try {
      await this.auth.loginWithKeychain(this.username);
      this.sound.coin();
      this.close();
    } catch (e: any) {
      this.error = e?.message ?? String(e);
      this.sound.error();
    }
  }
}
